export default {
    "name": "LoadCustomerDetails",
    "kind": "HoudiniQuery",
    "hash": "c2027f6ed7b1fbc65c62f7d79222faf011c03415add781ccc4e6c2e07497e038",

    "raw": `query LoadCustomerDetails($customerId: UInt!, $messageFilter: MessageFilter) {
  customer(id: $customerId) {
    id
    companyName
    balance
    accountLimit
    addresses {
      id
      label
    }
    messages(filter: $messageFilter) {
      id
      text
      type
      trigger
      important
    }
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "customer": {
                "type": "Customer",
                "keyRaw": "customer(id: $customerId)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "companyName": {
                            "type": "String",
                            "keyRaw": "companyName",
                            "visible": true
                        },

                        "balance": {
                            "type": "String",
                            "keyRaw": "balance",
                            "visible": true
                        },

                        "accountLimit": {
                            "type": "Decimal2",
                            "keyRaw": "accountLimit",
                            "visible": true
                        },

                        "addresses": {
                            "type": "CustomerAddress",
                            "keyRaw": "addresses",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "label": {
                                        "type": "String",
                                        "keyRaw": "label",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "messages": {
                            "type": "Message",
                            "keyRaw": "messages(filter: $messageFilter)",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "text": {
                                        "type": "String",
                                        "keyRaw": "text",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "type": {
                                        "type": "MessageType",
                                        "keyRaw": "type",
                                        "visible": true
                                    },

                                    "trigger": {
                                        "type": "MessageTrigger",
                                        "keyRaw": "trigger",
                                        "visible": true
                                    },

                                    "important": {
                                        "type": "Boolean",
                                        "keyRaw": "important",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "customerId": "UInt",
            "messageFilter": "MessageFilter"
        },

        "types": {
            "MessageFilter": {
                "active": "Boolean",
                "display": "MessageDisplay",
                "triggers": "MessageTrigger"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=d6ac642c2b93bfe64488fdafca63e68179eb09bb8e647cc2942bc2d7496d3c93";